const AnimatedDots = () => <span className="animated-dots" />;

export default AnimatedDots;
